import React from 'react'
import Heading from './heading'

const PageHeading = ({ children }) => (
  <div className="flex flex-col uppercase font-bold align-center content-center items-center">
    <Heading className="text-center md:whitespace-nowrap">{children}</Heading>
  </div>
)

export default PageHeading
